import { MedicalInformation } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { MedicalDataIcon, SidePanelList } from '@dreryk/react-components';

import { useMedicalDataCategoryListItems } from './MedicalDataSidePanelList.hooks';

type MedicalDataSidePanelListProps = {
   readonly medicalInformation: MedicalInformation[];
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const MedicalDataSidePanelList = (props: MedicalDataSidePanelListProps): JSX.Element => {
   return (
      <SidePanelList
         icon={<MedicalDataIcon />}
         items={useMedicalDataCategoryListItems(props.medicalInformation, props.onMedicalDataAccessAuthorizationUpdate)}
         noItemsMessage={createTranslatedText('')}
      />
   );
};
